import {RichTextEditor} from '@amzn/stencil-react-components/rte';
import {updateEventSolutionDetailsObject} from "src/state/slice/EventModelSlice";
import {useAppDispatch} from "src/state/hooks";
import "src/components/authoringComponents/styles/RichTextAuthoring.scss";
interface IRichTextAuthoring {
    attributeName: string;
    attributeValue: string;
}

export const RichTextAuthoring = ({attributeName, attributeValue}: IRichTextAuthoring) => {
    const dispatch = useAppDispatch();
    return <RichTextEditor
        defaultContent={attributeValue}
        onChange={editor => {
            dispatch(updateEventSolutionDetailsObject({
                [attributeName]: editor.getHTML(),
            }));
        }}
    />
}
